/*========================================================================
* $Id: voting.js -1M 2016-03-11 18:13:13Z (local) $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "client/templates",
    "api/v2/api",
    "client/resourceinfo",
    "api/v2/search",
    "client/template",
    "component!base",
    "i18n/i18n",
    "jquery",
    "underscore",
   ], function(
     Templates,
     API,
     ResourceInfo,
     Search,
     Template,
     Base,
     i18n,
     $,
     _
   ) {
              
  var Voting = Base.extend({

    voteUpHTML: function() {
      return "<i  class='icon-thumbs-up'></i>";
    },

    voteDownHTML: function() {
      return "<i  class='icon-thumbs-down'></i>";
    },

    initialize: function () {
      Base.prototype.initialize.apply(this, arguments);

      var that = this;
      var name = this.options.title;

       var enableVoting = $('[data-template="results"][data-enable-voting=true]').length;

       if(!enableVoting) return;

      API.search.on("compute", function(model, input) {
        //console.log(input);
      });

      API.search.on("loadoutput", (model, atts, options) => {
        const results = atts?.resultset?.results || atts?.results;
        if (!results) return;

        const createVoteHTML = (type, labelKey, iconHTML) => {
          return `<a tabindex="0"
                      aria-label="${i18n(labelKey)}"
                      role="button"
                      data-action-object='{"vote":{"action":"vote","weight":"${type}"}}'>
                      ${iconHTML}
                  </a>`;
        };

        const createVoteAction = (type, html) => ({
          html,
          value: {
            action: {
              [type === "up" ? "upvote" : "downvote"]: {}
            }
          }
        });

        const createPropertyBlock = (id, name, action) => ({
          id,
          name,
          data: [action]
        });

        results.forEach((result) => {
          const actions = result?.properties?.actions;
          if (!actions) return;

          // Generate buttons once
          const upHTML = createVoteHTML("up", "voting_leave_positive_reply", this.voteUpHTML());
          const downHTML = createVoteHTML("down", "voting_leave_negative_reply", this.voteDownHTML());

          const upAction = createVoteAction("up", upHTML);
          const downAction = createVoteAction("down", downHTML);

          // Push into actions.data (UI layer)
          if (actions.data) {
            actions.data.push(upAction, downAction);
          }

          // Push into actions.properties (config layer)
          if (actions.properties) {
            actions.properties.push(
              createPropertyBlock("UpVote", "UpVote", upAction),
              createPropertyBlock("DownVote", "DownVote", downAction)
            );
          }
        });
      });

        ///
        /*
          The Webpack was doing a static code analysis before actually running the script.
          
          Refrence logic:
          application.js 
         
          var enableVoting = $('[data-template="results"][data-enable-voting=true]').length;

          if (enableVoting) {
            if (isWebpack) {
              Mindbreeze.require(["voting"]);
            }
            else {
              Mindbreeze.require(["component!voting"]);
            }
          }
        */
        ///
        // var originalInitializeModels = Application.prototype.initializeModels;
        // _.extend(Application.prototype, {

        //   initializeModels: function() {
        //     originalInitializeModels.apply(this, arguments);
        //     this.listenTo(this, "queryprofilerdone", this.votingDone);
        //   },
        // });

    }

  });

  var VotingView = new Voting();
  return Voting;
});
